// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { Device, Desktop } from '../../components/Responsive';
import { LayoutDiv, ContentDiv, UnderlayDiv } from './LayoutStyles';
import Footer from './Footer';
import DeviceHeader from './DeviceHeader';
import Sidebar from './Sidebar';
import DesktopHeader from './DesktopHeader';
import { toggleSidebarDevice, logout } from '../../App/reducer';

type Props = {
  children: React.Node,
  toggleSidebarDevice: () => void,
  logout: () => void,
  currentRoute: string
};

class MainLayout extends React.Component<Props> {
  render() {
    return (
      <LayoutDiv currentRoute={this.props.currentRoute}>
        <Device>
          <DeviceHeader toggleSidebarDevice={this.props.toggleSidebarDevice} />
        </Device>
        <Desktop>
          <DesktopHeader
            logout={this.props.logout}
            currentRoute={this.props.currentRoute}
          />
        </Desktop>
        <Sidebar />
        <UnderlayDiv currentRoute={this.props.currentRoute}>
          <ContentDiv currentRoute={this.props.currentRoute}>
            {this.props.children}
          </ContentDiv>
        </UnderlayDiv>
        <Footer />
      </LayoutDiv>
    );
  }
}

const mapStateToProps = state => ({
  currentRoute: state.global.routes.to
});

const mapDispatchToProps = {
  toggleSidebarDevice,
  logout
};

export default connect(mapStateToProps, mapDispatchToProps)(MainLayout);
